import { render, staticRenderFns } from "./kycAuthselect.vue?vue&type=template&id=1f0f4c4a&scoped=true&"
import script from "./kycAuthselect.vue?vue&type=script&lang=js&"
export * from "./kycAuthselect.vue?vue&type=script&lang=js&"
import style0 from "./kycAuthselect.vue?vue&type=style&index=0&id=1f0f4c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f4c4a",
  null
  
)

export default component.exports